
// import { fetchScrapRecords, selectScrapRecord, resetCurrentScrapRecord } from '../../actions/scrapRecords_actions';
import { selectPutAway, fetchPutAway, resetCurrentPutAway } from '../../actions/putAway_actions';
import { connect } from 'react-redux';

import PutAway from '../../components/Inventories/putAway'

function mapStateToProps(state) {
    return {
        putAway: state.putAway.all,
        isLoading: state.putAway.isLoading,
        error: state.putAway.error,
        userPermissions: state.auth.userPermissions
    };
}



export default connect(mapStateToProps, { selectPutAway, fetchPutAway, resetCurrentPutAway })(PutAway);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/putAway.jsx